<template>
  <div class="mail-edit-box">
    <div class="main-container">
      <h2 class="">メール定型文編集</h2>
      <div class="list-box">
        <div class="flex">
          <div class="list-header-box">
            <p class="">ステータス</p>
          </div>
          <div class="list-contents-box">
            <p class="" v-if="list_item.type != 'm_1'">
              <input id="status2" type="radio" name="status" v-model="mail.status" value="2"/>
              <label for="status2">有効</label>
              <input id="status1" type="radio" name="status" v-model="mail.status" value="1"/>
              <label for="status1">無効</label>
            </p>
            <p v-else>
              <input id="status2" type="radio" name="status" v-model="mail.status" value="2"/>
              <label for="status2">有効</label>
            </p>
          </div>
        </div>
        <div class="flex">
          <div class="list-header-box">
            <p class="">送信タイミング</p>
          </div>
          <div class="list-contents-box">
            <p class="">{{list_item.name}}</p>
          </div>
        </div>
        <div class="flex" v-if="param_chk">
          <div class="list-header-box">
            <p class="">パラメータ</p>
          </div>
          <div class="list-contents-box">
            <p class="">
              <span v-if="list_item.type == 'm_4' || list_item.type == 'm_5' || list_item.type == 'm_6'">
                チェックイン日の
                <input type="number" class="param" min="1" max="30" v-model.number="mail.param2">日前、
              </span>
              <span>
                <input type="number" class="param" min="0" max="23" v-model.number="mail.param1">時に送信
              </span>
            </p>
          </div>
        </div>
      </div>

      <div class="mail-info">
        <div class="var-list-box">
          <h3>変数</h3>
          <div class="var-list-box-rap">
            <div class="var-list" v-for="(list, index) in var_list" :key="index">
              <p class="var-name">{{list.name}}：</p>
              <p class="var-value">{{list.type}}</p>
            </div>
          </div>
        </div>
        <div class="mail-sub-info">
          <h3>メール内容（英語）</h3>
          <h4>タイトル（英語）</h4>
          <input type="text" name="" v-model="mail.subject_en">
          <h4>本文（英語）</h4>
          <textarea name="name" rows="20" cols="80" v-model="mail.content_en"></textarea>
          <p class="red" v-if="list_item.type == 'm_1'">※本文の最下行にログインID、パスワードが記載されます。</p>
        </div>
        <div class="mail-sub-info">
          <h3>メール内容（日本語）</h3>
          <h4>タイトル</h4>
          <input type="text" name="" v-model="mail.subject_ja">
          <h4>本文</h4>
          <textarea name="name" rows="20" cols="80" v-model="mail.content_ja"></textarea>
          <p class="red" v-if="list_item.type == 'm_1'">※本文の最下行にログインID、パスワードが記載されます。</p>
        </div>
      </div>

      <div class="btn-box">
        <input type="button" class="new-add" name="" @click="back()" value="戻る">
        <input type="button" class="new-add" name="" @click="edit()" value="設定する">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MailEdit',
  // ===========================================================================
  // components
  // ===========================================================================
  components: {
  },
  // ===========================================================================
  // data
  // ===========================================================================
  data () {
    return {
      list_item: {},
      mail: {id: 0, status: 1},
      listing_id: 1,
      var_list: [],
    };
  },
  // ===========================================================================
  // computed
  // ===========================================================================
  computed: {
    param_chk () {
      if (
        this.list_item.type === 'm_4'
         || this.list_item.type === 'm_5'
         || this.list_item.type === 'm_6'
         || this.list_item.type === 'm_7'
         || this.list_item.type === 'm_8'
         || this.list_item.type === 'm_9'
      ) {
        return true;
      }
      return false;
    }
  },
  // ===========================================================================
  // created
  // ===========================================================================
  created () {
    this.listing_id = this.$route.params.listing_id;
    this.list_item = this.$route.params.list;
    if (this.list_item.type === 'm_1') {
      // 強制的にstatusを有効に設定
      this.mail.status = 2;
    }

    this.val_get();
  },
  // ===========================================================================
  // mounted
  // ===========================================================================
  mounted () {
  },
  // ===========================================================================
  // destroyed
  // ===========================================================================
  destroyed () {
  },
  // ===========================================================================
  // methods
  // ===========================================================================
  methods: {
    val_get () {
      let ld = new this.$loader(this);
      ld._data_set({});
      ld._post_cb_f = this.val_get_cb;
      ld._load_start('mail_template_variable_list_get.php');
    },
    val_get_cb (res) {
      this.var_list = res.data.variables;
      if (this.list_item.id !== 0) {
        this.data_get();
      }
    },
    data_get () {
      let ld = new this.$loader(this);
      ld._data_set({id: this.list_item.id});
      ld._post_cb_f = this.data_get_cb;
      ld._load_start('mail_template_get.php');
    },
    data_get_cb (res) {
      this.mail = res.data.mail_template;
    },
    edit () {
      if (this.param_chk === true && this.$lib._emptyChk(this.mail.param1) === false) {
        this.$alert('alert', 'パラメータを入力してください。');
        return;
      }
      if (this.param_chk === true && this.mail.param1 > 23) {
        this.$alert('alert', '0 ~ 23を入力してください。');
        return;
      }
      if (
        this.$lib._emptyChk(this.mail.subject_ja) === false
         || this.$lib._emptyChk(this.mail.content_ja) === false
         || this.$lib._emptyChk(this.mail.subject_en) === false
         || this.$lib._emptyChk(this.mail.content_en) === false
      ) {
        this.$alert('alert', 'タイトル、本文を入力してください。');
        return;
      }

      if (!this.mail.listing_id) {
        this.mail.listing_id = this.listing_id;
        this.mail.type = this.list_item.type;
      }

      let ld = new this.$loader(this);
      ld._data_set({mail_template: this.mail});
      ld._post_cb_f = this.edit_cb;
      ld._load_start('mail_template_edit.php');
    },
    edit_cb () {
      this.$alert('info', 'メール定型文を設定しました。');
      this.back();
    },
    back () {
      this.$router.push({name: 'mail_list', params: {listing_id: this.listing_id}});
    }
  },
  // ===========================================================================
  // watch
  // ===========================================================================
  watch: {
  },
};
</script>

<style lang="scss">
.mail-edit-box {
  text-align: left;
  h3 {
    margin-bottom: 5px;
  }
  h4 {
    margin-top: 15px;
  }
  .main-container {
    .new-add {
      color: #fefefe;
      display: block;
      text-align: center;
      padding: 8px 8px 8px 8px;
      font-size: 16px;
      margin: 30px auto 10px auto;
      text-decoration: none;
      border-radius: 3px;
      width: 150px;
    }
    .list-box {
      overflow-y: auto;
      border-bottom: 1px solid #ceced2;
    }
    .list-header-box {
      p {
        background: #fbfbfb;
        border-top: 1px solid #ceced2;
        border-left: 1px solid #ceced2;
        padding: 8px;
        color: #24273b;

        text-align: right;
        box-sizing: border-box;
        height: 40px;
        width: 130px;
      }
    }
    .list-contents-box {
      flex: 1;
      p {
        background: #fbfbfb;
        border-top: 1px solid #ceced2;
        border-left: 1px solid #ceced2;
        border-right: 1px solid #ceced2;
        padding: 8px;

        box-sizing: border-box;
        height: 40px;
      }
    }
    .param {
      width: 60px;
    }
    .mail-info {
      display: flex;
      margin: 20px 0 0 0;
    }
    .var-list-box-rap {
      height: calc(100vh - 372px);
      overflow-y: auto;
    }
    .var-list-box {
      width: 180px;
      background: #fbfbfb;
      margin-right: 20px;
      padding: 10px;
    }
    .var-list {
      padding: 5px 0;
      border-bottom: 1px solid #dddddd;
      .var-name {
        font-size: 0.8rem;
        margin-bottom: 5px;
      }
      .var-value {
        font-weight: 800;
        user-select: all;
      }
    }
    .mail-sub-info {
      flex: 1;
      background: #fbfbfb;
      margin-right: 20px;
      padding: 10px;
    }
    .mail-sub-info:last-child {
      margin-right: 0;
    }

    .btn-box {
      display: flex;
      width: 50%;
      margin: 0 auto;
    }
  }
  .red {
    color: #ff6e5a;
  }
  @media (max-width: 767px) {
    .main-container {
      .mail-info {
        display: block;
      }
      .list-header-box {
        p {
          box-sizing: border-box;
          height: 65px;
        }
      }
      .list-contents-box {
        p {
          box-sizing: border-box;
          height: 65px;
        }
      }
      .var-list-box {
        box-sizing: border-box;
        width: 100%;
        margin-right: 0;
      }
      .mail-sub-info {
        margin-top: 10px;
        margin-right: 0;
      }
      .btn-box {
        width: 100%;
        margin: 0;
      }
    }
  }
}
</style>
